import { cn } from '@/lib/cn';

/**
 * Brand logo rendered as a CSS mask tinted with `currentColor`, so it inherits
 * the surrounding text color — white over the hero, ink elsewhere — from a
 * single transparent asset. Set the height via className; width follows the ratio.
 */
export function Logo({ className }: { className?: string }) {
  return (
    <span
      role="img"
      aria-label="Silvana Barbato — Studio Atelier"
      className={cn('block bg-current', className)}
      style={{
        aspectRatio: '953 / 587',
        WebkitMaskImage: 'url(/logo-mask.png)',
        maskImage: 'url(/logo-mask.png)',
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'left center',
        maskPosition: 'left center',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
      }}
    />
  );
}
